import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

type QuoteRequest = ClientInferResponseBody<typeof contract.quoteRequests.create>;

export const createQuoteRequest = async (): Promise<QuoteRequest | null> => {
  const response = await api.quoteRequests.create.mutation({
    body: {},
  });

  if (response.status === 201) {
    return response.body;
  }

  return null;
};
